export default function orderCancellationConfigMap(config?: App.CancellationConfig): App.OrderItemHotelCancellationConfig {
  return {
    policyType: config?.policy_type || 'non-refundable',
    policyDeadline: config?.policy_deadline || '',
    policyDeadlineInstant: config?.policy_deadline_details?.instant ?? undefined,
    canUseBookingProtection: config?.can_use_booking_protection || false,
    canUseInsuranceBookingProtection: config?.can_use_insurance_booking_protection ?? false,
    canUseCancellationProtection: config?.can_use_cancellation_protection || false,
    canAutoRefund: config?.can_auto_refund || false,
    canRequestRefund: config?.can_request_refund || false,
    canRefundToOrigin: config?.can_refund_to_origin || false,
    canRefundToCredit: config?.can_refund_to_credit || false,
    changeOfMindEndDate: config?.change_of_mind_end_date ?? undefined,
    canRefund: config?.can_refund || false,
    blockAutoRefundReasons: config?.block_auto_refund_reasons || [],
    canChangeGuestName: config?.can_change_guest_name ?? false,
    blockGuestNameChangeReasons: config?.block_guest_name_change_reasons || [],
    canChangeDates: config?.can_change_dates ?? false,
    canExtendDates: config?.can_extend_dates ?? false,
    canReduceDates: config?.can_reduce_dates ?? false,
    blockDateChangeReasons: config?.block_reasons?.block_date_change_reasons || [],
    blockDateExtendReasons: config?.block_reasons?.block_date_extend_reasons || [],
    blockDateReduceReasons: config?.block_reasons?.block_date_reduce_reasons || [],
    canRequestDateChange: config?.can_request_date_change ?? false,
    canUpgradePackage: config?.can_upgrade_package || false,
    sendToRetention: config?.send_to_retention ?? false,
    luxProtectEligible: config?.lux_protect_eligible,
    luxProtectInsuranceItemId: config?.lux_protect_insurance_item_id,
    airlineRefundOptions: config?.airline_refund_options?.map(option => ({
      scope: option.scope,
      legIds: option.leg_ids,
      status: option.status,
      quote: option.quote ? {
        amount: option.quote.amount,
        currency: option.quote.currency,
        handlingFee: option.quote.handling_fee,
        nonRefundableTaxAmount: option.quote.non_refundable_tax_amount,
        airlineFees: option.quote.airline_fees.map(fee => ({
          carrier: fee.carrier,
          amount: fee.amount,
          currency: fee.currency,
          isGstIncluded: fee.is_gst_included,
        })),
      } : undefined,
    })),
    jetstarVoucherEligible: config?.jetstar_voucher_eligible,
  }
}
